/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
// /* eslint-disable no-restricted-globals */
import React, { useState, useEffect, useContext } from 'react';
import { Rnd } from 'react-rnd';
import { Box, MenuItem, Select, Modal, Stack, Grid, Button, Tooltip, Checkbox, ToggleButton, ToggleButtonGroup, Typography, styled, Switch, FormControlLabel, Radio, RadioGroup, } from '@mui/material';
import Chart from 'react-apexcharts';
import { VeoliaInput } from '@veolia.com/vds-react-components';
import { closeIconBlack, feed_water } from '../../shared/assets/images';
import { defaultModalOptions, defaultUnitValues } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import './parametric.scss';
import { ExecuteContext } from '../Flow';

const BatchSimulationResults = (props) => {
  const { visibleParametric, translateObject, ediOutputData, handleCloseParametric } = props;
  const [streamActive, setStreamActive] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [decimalVal, setDecimalVal] = useState(3);
  const jsonData = JSON.parse(localStorage.getItem('stream_ouput_data')) || {};
  const unitData = JSON.parse(localStorage.getItem('unit_set_dict')) || {};
  const [unit_set_dict] = useState(unitData);
  const defaultNum = Object.keys(jsonData)[0];
  const defaultJsonData = jsonData[defaultNum];
  const [streamjsonData, setStreamjsonData] = useState(defaultJsonData);
  const [streamNum, setStreamNum] = useState(defaultNum);
  const navlist_names = []; // creating steamdata name list
  const [y_axis_value_select, set_y_axis_value_select] = useState('');
  const [y_axis_value_select1, set_y_axis_value_select1] = useState([]);

  function getUnitValue(item) {
    if (item === 'Pressure') {
      return `${unit_set_dict.Pressure}` || 'atm';
    } if (item === 'Flow') {
      return `${unit_set_dict['Volume Flow']}` || 'gpm';
    } return '';
  }

  const [y_axis_data, setYAxisData] = useState([{
    key: 'Ion Composition',
    data: [
      { key: 'Calcium (Ca)', value: 'Calcium (Ca)' },
      { key: 'Magnesium (Mg)', value: 'Magnesium (Mg)' },
      { key: 'Sodium (Na)', value: 'Sodium (Na)' },
      { key: 'Potassium (K)', value: 'Potassium (K)' },
      { key: 'Ammonia - N (NH4)', value: 'Ammonia - N (NH4)' },
      { key: 'Barium (Ba)', value: 'Barium (Ba)' },
      { key: 'Strontium (Sr)', value: 'Strontium (Sr)' },
      { key: 'Iron (Fe)', value: 'Iron (Fe)' },
      { key: 'Manganese (Mn)', value: 'Manganese (Mn)' },
      { key: 'Sulfate (SO4)', value: 'Sulfate (SO4)' },
      { key: 'Chloride (Cl)', value: 'Chloride (Cl)' },
      { key: 'Fluoride (F)', value: 'Fluoride (F)' },
      { key: 'Nitrate (NO3)', value: 'Nitrate (NO3)' },
      { key: 'Bromide (Br)', value: 'Bromide (Br)' },
      { key: 'Phosphate (PO4)', value: 'Phosphate (PO4)' },
      { key: 'Boron (B)', value: 'Boron (B)' },
      { key: 'Silica (SiO2)', value: 'Silica (SiO2)' },
      { key: 'Hydrogen Sulfide (H2S)', value: 'Hydrogen Sulfide (H2S)' },
      { key: 'Bicarbonate (HCO3)', value: 'Bicarbonate (HCO3)' },
      { key: 'Carbon Dioxide (CO2)', value: 'Carbon Dioxide (CO2)' },
      { key: 'Carbonate (CO3)', value: 'Carbonate (CO3)' },
    ]
  }, {
    key: 'Stream Properties',
    data: [
      { key: `${translateObject('Flow')}, ${getUnitValue('Flow')}`, value: `${translateObject('Flow')}, ${getUnitValue('Flow')}` },
      { key: `${translateObject('Temperature')}, ${unit_set_dict.Temperature}`, value: `${translateObject('Temperature')}, ${unit_set_dict.Temperature}` },
      { key: `${translateObject('Pressure')}, ${getUnitValue('Pressure')}`, value: `${translateObject('Pressure')}, ${getUnitValue('Pressure')}` },
      { key: 'TDS, mg/l', value: 'TDS, mg/l' },
      { key: 'pH', value: 'pH' },
      { key: `${translateObject('Alkalinity')}, ppm CaCO3`, value: `${translateObject('Alkalinity')}, ppm CaCO3` },
      { key: 'Hardness, ppm as CaCO3 ', value: 'Hardness, ppm as CaCO3 ' },
      { key: `${translateObject('Hardness')}, ppm as CaCO3`, value: `${translateObject('Hardness')}, ppm as CaCO3` },
      { key: `${translateObject('Density')}, kg/m3`, value: `${translateObject('Density')}, kg/m3` },
      { key: `${translateObject('Ionic Strength')}`, value: `${translateObject('Ionic Strength')}` },
      { key: `${translateObject('Osmotic Pressure')}, ${getUnitValue('Pressure')}`, value: `${translateObject('Osmotic Pressure')}, ${getUnitValue('Pressure')}` },
      { key: `${translateObject('Conductivity')}, µS/cm `, value: `${translateObject('Conductivity')}, µS/cm ` },
    ]
  },
  {
    key: 'Saturation Data',
    data: [
      { key: 'BaSO4 Saturation', value: 'BaSO4 Saturation' },
      { key: 'CaF2 Saturation', value: 'CaF2 Saturation' },
      { key: 'CaSO4 Saturation', value: 'CaSO4 Saturation' },
      { key: 'SiO2 Saturation', value: 'SiO2 Saturation' },
      { key: 'Mg(OH)2 Saturation', value: 'Mg(OH)2 Saturation' },
      { key: 'SrSO4 Saturation', value: 'SrSO4 Saturation' },
      { key: 'Struvite Saturation', value: 'Struvite Saturation' },
      { key: 'Langelier Index', value: 'Langelier Index' },
      { key: 'Stiff-Davis Index', value: 'Stiff-Davis Index' }
    ]
  }]);

  const setYAxisValue = (event) => {
    set_y_axis_value_select(event.target.value || '');
    const data = y_axis_data.filter((ele) => {
      return ele.key === event.target.value;
    });
    console.log(data);
    set_y_axis_value_select1(data[0].data);
  };

  Object.entries(jsonData).forEach(([key, value]) => {
    const obj = {}; // creating object
    obj.key = key;
    obj.label = value.label === null ? '' : value.label;
    navlist_names.push(obj); // pushing object values to steamdata list
  });
  console.log(navlist_names);
  const b_val = 'Dosage, Kg/day';
  const feedName = 'CLRO';
  const state = {
    options: {
      chart: {
        id: 'basic-bar'
      },
      xaxis: {
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
      }
    },
    series: [
      {
        name: 'series-1',
        data: [30, 40, 45, 50, 49, 60, 70, 91]
      }
    ]
  };
  const handleCloseParametricModal = () => {
    handleCloseParametric();
  };
  const streamData = (params, i) => {
    setStreamNum(params);
    setStreamActive(i);
    setStreamjsonData(jsonData[params]);
    setIsLoading(true);
    // GB-2259 chandrashekhar kumar added.
    setDecimalVal(3);
    if (ediOutputData && ediOutputData.length > 0) {
      for (let i = 0; i < ediOutputData.length; i += 1) {
        if (ediOutputData[i].data.text === Number(params)) {
          setDecimalVal(5);
          break;
        }
      }
    }
    // GB-2259 chandrashekhar kumar added.
  };
  const submitForm = (closeForm = true) => {

  };
  return (
    <Grid container className='parametric-grid-container parametric-wrapper'>
      <Grid item xs={12} className='parametric-header-grid'>
        <div className='parametric-grid-title rufusBld no_drag S_heading'>Batch simulation Results</div>
        <div className='parametric-grid-container no_drag'>
          <Tooltip title='Close'>
            <img
              src={closeIconBlack}
              alt='close'
              onClick={handleCloseParametricModal}
              style={{ width: '14px', padding: '11px' }}
              className='pointer'
            />
          </Tooltip>
        </div>
      </Grid>
      <Grid item xs={12} className='parametric-body-container sansW4SeLig'>
        <Grid item xs={12}>
          <Grid item xs={12} style={{ height: 'auto', overflow: 'hidden' }} className='views-content-grid views-height'>
            <div className="card-container">
              <Grid container style={{ height: '65vh', overflow: 'scroll' }}>
                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                  <h5 className="view-sub-title rufusBld no_drag M_heading">{translateObject('')}</h5>
                  <div className="info-timeline">
                    <ul className="stream-scroller" style={{
                      height: '55vh', border: ' 1px solid #e9e6f4',
                      padding: 10, borderRadius: 10
                    }}>
                      {navlist_names.map((item, i) => (
                        <li key={`aa${Math.random().toString(36).slice(2, 7)}`} className={streamActive === i ? 'active' : 'not-active'} style={{ position: 'relative' }}>
                          <span className={`hide ${streamActive === i ? 'SteamActived timeline-circle' : 'SteamUNActived timeline-circle'}`}
                            style={{ backgroundColor: streamActive === i ? '#0679CC' : '#E0DDEE', color: streamActive === i ? '#FCFCFC' : '75748B' }}
                            onClick={() => streamData(item.key, i)} >
                            {item.key}
                          </span>
                          <span id="align-value" className={streamActive === i ? 'SteamActived no_drag' : 'SteamUNActived no_drag'}
                            onClick={() => streamData(item.key, i)}>{item.label}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={9} xl={9} style={{ padding: 40 }}>
                  <div style={{ display: isLoading ? '' : 'none' }}>
                    <div className="pleaseWaitText" style={{ color: '#000' }}> {translateObject('Loading Please wait...')}</div>
                  </div>
                  <Grid item xs={12} sm={12} md={12} lg={9} xl={9} className='parametirc-right-section'>
                    <div className='para-padding'> Y Axis</div>
                    <div className='para-padding para-align'>
                      <div className='para_feed'>
                        <Select
                          value={String(y_axis_value_select)}
                          name="waterSource"
                          style={{ width: '90%', height: '25px' }}
                          fullWidth
                          className="parametric_select"
                          onChange={(event) => setYAxisValue(event)}
                          data-testid='waterSource-1'
                        >
                          {y_axis_data.map((val) => (
                            <MenuItem key={val.key} value={String(val.key)}>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: translateObject(val.key)
                                }}
                              />
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      <div className='para_feed'>
                        <Select
                          value={String('')}
                          name="waterSource"
                          style={{ width: '90%', height: '25px' }}
                          fullWidth
                          className="parametric_select"
                          onChange={(event) => console.log(1111)}
                          data-testid='waterSource-1'
                        >
                          {y_axis_value_select1.map((val) => (
                            <MenuItem key={val.key} value={String(val.value)}>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: translateObject(val.value)
                                }}
                              />
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <Chart id="dashboard_bar" options={state.options} series={state.series} type="bar" width="100%" height='150' />
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div className='parametric-button'>
          <Stack spacing={2} direction='row'>
            <Button variant='contained M_Bold Secondary-Default_button btn-auto-width' size='small' className=' sansW4SeLig'
              style={{ border: 'none' }}
              onClick={handleCloseParametricModal}> {translateObject('Cancel')} </Button>
            <Button variant='contained M_Bold Primary_Default_Button btn-auto-width' size='small' className=' sansW4SeLig'
              onClick={submitForm}> {translateObject('Submit')} </Button>
          </Stack>
        </div>
      </Grid>
    </Grid>
  );
};
export default BatchSimulationResults;
